import React from 'react';

export const InfoSection = ({title, children}) =>{
    return(
        <div className='bg-stone-100 dark:bg-stone-600'>
            <div className='flex flex-col w-full px-6 xl:px-20 2xl:px-40 pb-4 xl:pb-8 mt-4'>
                <div className='flex justify-center py-3 xl:py-8 2xl:py-10 font-bold xl:text-4xl 2xl:text-5xl dark:text-white'>{title}</div>
                {children}
            </div>
        </div>
    )
}
